import { render, staticRenderFns } from "./largeSizeDetailsImport.vue?vue&type=template&id=b20433d8&scoped=true&"
import script from "./largeSizeDetailsImport.vue?vue&type=script&lang=js&"
export * from "./largeSizeDetailsImport.vue?vue&type=script&lang=js&"
import style0 from "./largeSizeDetailsImport.vue?vue&type=style&index=0&id=b20433d8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20433d8",
  null
  
)

export default component.exports